import { computed } from 'vue'
import { useStore } from 'vuex'

export function useLanguages() {
    const store = useStore()
    const languages = computed(() => store.state.lang.languages)

    function getLanguageName(code) {
        for (const lang of languages.value) {
            if (lang.code === code) return lang.name
            const dialect = lang.dialects?.find(d => d.code === code)
            if (dialect) return dialect.name
        }
        return code
    }

    return { languages, getLanguageName }
}
